<div class="share-accept">
  <div class="card" *ngIf="loading">
    <div class="spinner"></div>
    <p>{{ 'share.accept.loading' | translate }}</p>
  </div>

  <div class="card" *ngIf="!loading && (!info || !info.valid)">
    <h2>{{ 'share.accept.invalid_title' | translate }}</h2>
    <p class="muted">{{ invalidReasonKey | translate }}</p>
    <button (click)="home()">{{ 'common.home' | translate }}</button>
  </div>

  <div class="card" *ngIf="!loading && info && info.valid && !result">
    <h2>{{ 'share.accept.title' | translate }}</h2>
    <p [innerHTML]="'share.accept.intro' | translate: { user: info.invitedBy, controller: info.controllerName }"></p>
    <p>{{ 'share.accept.level' | translate }}: <b>{{ levelKey(info.level) | translate }}</b></p>
    <div class="actions">
      <button class="primary" [disabled]="accepting" (click)="accept()">
        {{ (accepting ? 'share.accept.accepting' : 'share.accept.accept') | translate }}
      </button>
      <button (click)="home()">{{ 'common.cancel' | translate }}</button>
    </div>
  </div>

  <div class="card" *ngIf="result">
    <ng-container *ngIf="result.ok; else failed">
      <h2>{{ 'share.accept.done_title' | translate }}</h2>
      <p>{{ 'share.accept.done_body' | translate: { controller: result.name } }}</p>
    </ng-container>
    <ng-template #failed>
      <h2>{{ 'share.accept.failed_title' | translate }}</h2>
      <p class="muted">{{ failedReasonKey | translate }}</p>
      <button (click)="home()">{{ 'common.home' | translate }}</button>
    </ng-template>
  </div>
</div>
